// src/utils/DropDown.js
import React, { useState, useEffect, useRef } from 'react';
// import settings from "../utils/settings";
import SvgIcon from "./SvgIcon";
import './Dropdown.css';

function DropdownList({
  options,
  cb={
    input_:()=>{},
    setSearch_:()=>{},
    setData_:()=>{},
    defVal:'',
    setIds:null , //при редактировании задачи, устанавливаем активных пользователей (ответств./команда)
  },
  multiple=false,
}) {
  const [isOpen, setIsOpen] = useState(false)
    , [isCached, setIsCached] = useState(false)
    , [selectedItems, setSelectedItems] = useState([])
    , [cachedItems, setCachedItems] = useState([])
    , [cached2Items, setCached2Items] = useState([])
    , [selectedNames, setSelectedNames] = useState('')
    , [searchTerm, setSearchTerm] = useState("")
    , dropdownRef = useRef(null) // Реф для выпадающего списка
    , toggleDropdown = () => setIsOpen(!isOpen)
    , handleSelect = (option) => {
        let updatedItems;
        if (multiple) {
          // Режим мультивыбора
          if (selectedItems.includes(option)) {
            updatedItems = selectedItems.filter(item => item !== option);
          } else {
            updatedItems = [...selectedItems, option];
          }
        } else {
          // Режим одиночного выбора
          updatedItems = [option];
          setIsOpen(false); // Закрываем меню после выбора
        }
        setSelectedItems(updatedItems); // Обновляем состояние
        cb.setData_((prev) => ({ ...prev, company: updatedItems[0].id })); // Вызываем колбэк с обновленным значением
      }
    , isSelected = (option) => selectedItems.includes(option)
    , handleSearch = (term) => {
        setSearchTerm(term);
        if (term === '') {
          setCachedItems(cached2Items); // Возвращаем полный список, если строка поиска пуста
          return;
        }
        const filtered = options.filter((company) =>
          company.name.toLowerCase().includes(term.toLowerCase())
        );
        if (filtered.length > 0) {
          setCachedItems(filtered); // Устанавливаем результат поиска
        }else{
          setCachedItems(cached2Items); // Устанавливаем изначальное значение
        }
      }
  ;
  // Закрытие меню при клике вне области
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('pointerdown', handleClickOutside);
    // Удаляем обработчик при размонтировании
    return () => {
      document.removeEventListener('pointerdown', handleClickOutside);
    };
  }, []);
  useEffect(() => {
    if(cb.setIds && !Array.isArray(cb.setIds))cb.setIds=[cb.setIds]
    if (cb.setIds && Array.isArray(cb.setIds)) {
      const preselectedUsers = options.filter(user => cb.setIds.includes(user.id));
      setSelectedItems(preselectedUsers);
    }
  }, [cb.setIds, options]);
  // Синхронизируем `selectedNames` при изменении `selectedItems`
  useEffect(() => {
    const names = selectedItems
      .map(item => (item.name === '' ? item.phone : item.name))
      .join(', ');
    setSelectedNames(names);
  }, [selectedItems]);
  useEffect(() => {
    if(!isCached && Array.isArray(options) && options.length>0){
      setIsCached(true)
      setCachedItems(options)
      setCached2Items(options)
    }
  }, [options]);

  return (
    <div className="pr dd" ref={dropdownRef}>
      <button className="cf fwb dd-toggle" onClick={toggleDropdown}>
        {selectedItems.length > 0 ? selectedNames : 'Выбрать из списка'}
      </button>
      {isOpen && (
        <div className="pd bx dd-menu">
          <span className="fx gap1 mb">
            <span className="pr fx ac">
              <input
                type="text"
                className="ddInpSrc"
                name="phone"
                placeholder="Поиск"
                minLength="2" maxLength="80"
                defaultValue={cb.defVal}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <button
                className="pa fs0 btn ddBtnSrc"
                title="Поиск"
                onClick={()=>handleSearch(searchTerm)}
              >Поиск
                <SvgIcon hash="lens" width="30"/>
              </button>
            </span>
          </span>
          <div className="ova">
            {cachedItems.map((option) => (
              <span
                key={option?.id}
                className="dd-item"
                onClick={() => handleSelect(option)}
              >
                <span className="dd-nm">
                  {option.name}
                </span>
                <span className={`fs0 dd-mark${isSelected(option) ? ' dd-markCl' : ''}`}>+</span>
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default DropdownList;